import { Option, Value } from 'baseui/select';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ActionType } from 'components/elements/table/type';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { useGroupDetailTableList } from './table-column';
import {
  CruisePurchaseDetailsItemFormType,
  CruisePurchaseFormType,
  CruisePurchaseGuestItemFormType,
} from '../../form-type';

interface Props {
  parentIndex: number;
  guest: CruisePurchaseGuestItemFormType;
  cruiseRoomList: Option[];
}

export default function CruiseGuestDetailTable(props: Props) {
  const { editable } = useFormState();
  const { setValue, getValues, clearErrors } =
    useFormContext<CruisePurchaseFormType>();

  const detailsName =
    `cruisePurchases.${props.parentIndex}.cruisePurchaseDetails` as const;

  const guestIndex = getValues(detailsName).findIndex(
    (item) => item.guestDetailId === props.guest.guestDetailId,
  );

  const columns = useGroupDetailTableList(props.cruiseRoomList);

  const dispatch = React.useCallback(
    (action) => {
      const details = getValues(detailsName);
      const currentRowIndex = guestIndex;
      const detail = details[currentRowIndex];
      const type = action.type as ActionType;
      const columnId =
        action.columnId as keyof CruisePurchaseDetailsItemFormType;
      const extra = action.extra as Value;
      const value = action.value;

      const otherVal: () => Partial<CruisePurchaseDetailsItemFormType> = () => {
        if (columnId === 'cruiseRoomId') {
          return {
            cruiseRoomName: extra?.[0]?.label as string,
          };
        }
        return {};
      };

      if (type === 'update_cell') {
        setValue(`${detailsName}.${guestIndex}`, {
          ...detail,
          [columnId]: value,
          ...otherVal(),
        });
        clearErrors(`${detailsName}.${guestIndex}.${columnId}`);
      }
    },
    [clearErrors, getValues, detailsName, guestIndex, setValue],
  );

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={[getValues(detailsName)[guestIndex]]}
        dispatch={dispatch}
        disabled={!editable}
        noAddRemoveRow
        name={detailsName}
        uniqueRowKey="customId"
      />
    </div>
  );
}
